//src/pages/NoteFlexPagesList.jsx
import React, { useCallback, useEffect, useState, useRef } from 'react';
import { useSelector } from 'react-redux';
import { Link, useLocation } from 'react-router-dom';
import useFetch from '../../hooks/useFetch';
import 'react-datepicker/dist/react-datepicker.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus } from '@fortawesome/free-solid-svg-icons';
import Loader from '../../components/utils/Loader';
import Tooltip from '../../components/utils/Tooltip';
import MainLayout from '../../layouts/MainLayout';

const NoteFlexPagesList = () => {
  const authState = useSelector(state => state.authReducer);
  const { isLoggedIn } = authState;
  const [noteFlexPages, setNoteFlexPages] = useState([]);
  const [fetchData, { loading }] = useFetch();
  const [selectedNoteFlexPageId, setSelectedNoteFlexPageId] = useState(null);
  const [deletePageId, setDeletePageId] = useState(null); 

  useEffect(() => {
    document.title = authState.isLoggedIn ? `${authState.user.name}'s dashboard` : "Think5Whys";
  }, [authState]);


  const fetchNoteFlexPages = useCallback(() => {
    const config = {
        url: "/usernoteflexpages/mypagesfull",    //mypagesfull
        method: "post",
        headers: { Authorization: authState.token },
        data: { userId: authState.user._id}
      };
      
    // console.log("NoteFlex Book Search Payload: ", config);
  
    fetchData(config, { showSuccessToast: false }).then(data => setNoteFlexPages(data.userNoteFlexPages));
  }, [authState.token, fetchData, authState.user._id]);
  
  useEffect(() => {
    if (!authState.isLoggedIn) return;
    fetchNoteFlexPages();
  }, [authState.isLoggedIn, fetchNoteFlexPages]);

  const [isDeleteClicked, setIsDeleteClicked] = useState(false);
  
  const deleteClicked = (id) => {
    setDeletePageId(id);
    setIsDeleteClicked(true);
  }
  
  const noDeleteClicked = () => {
    setIsDeleteClicked(false);
  }

  const handleDelete = (id) => {
    // sID to delete: ",id);
    const config = {
      url: `/usernoteflexpages/${id}`,
      method: "delete",
      headers: { Authorization: authState.token }
    };
    fetchData(config).then(() => fetchNoteFlexPages());
    setIsDeleteClicked(false);
  }

  const handleView = (noteFlexPageId) => {
    setSelectedNoteFlexPageId(prevId => (prevId === noteFlexPageId ? null : noteFlexPageId));
  };

  const handleNoteFlexPageShare = (noteFlexPageId) => {
    setSelectedNoteFlexPageId(noteFlexPageId);
  };

  const handleNoteFlexPageSave = (noteFlexPageId) => {
    setSelectedNoteFlexPageId(noteFlexPageId);
  };

  const handleNoteFlexPagePrint = (noteFlexPageId) => {
    setSelectedNoteFlexPageId(noteFlexPageId);
  };

  const formatDateTime = (date) => {
    const options = {
        year: 'numeric', month: '2-digit', day: '2-digit',
        hour: '2-digit', minute: '2-digit', second: '2-digit',
        hour12: false
    };
    const jsDate = new Date(date);
    const day = jsDate.getDate().toString().padStart(2, '0');
    const month = (jsDate.getMonth() + 1).toString().padStart(2, '0');
    const year = jsDate.getFullYear();
    const hours = jsDate.getHours().toString().padStart(2, '0');
    const minutes = jsDate.getMinutes().toString().padStart(2, '0');
    const seconds = jsDate.getSeconds().toString().padStart(2, '0');
    return `${day}-${month}-${year} ${hours}:${minutes}:${seconds}`;
};

const sortedNoteFlexPages = [...noteFlexPages].sort((a, b) => b.pageNumber - a.pageNumber);
const pageNumberList = noteFlexPages.map(page => page.pageNumber);

  return (
    <>
      <MainLayout>
        <div className="min-h-full py-8 bg-gradient-to-r from-purple-300 via-blue-500 to-yellow-200 mt-12">
          <h2 className='text-3xl font-bold text-white text-center mb-2'>My Own NoteFlex Book Pages</h2>
{/* {pageNumberList && Array.isArray(pageNumberList) && pageNumberList.length > 0 ? (
  <ul>
    {pageNumberList.map((pageNumber, index) => (
      <li key={index}>
        {pageNumber},
      </li>
    ))}
  </ul>
) : (
  <p>No pages available</p>
)}     */}
            <div className="border border-gray-300 p-4 mt-4">
              <div className="mt-2">
                  {noteFlexPages && noteFlexPages.length !== 0 && (
                    <div className="flex justify-between items-center border-b border-b-gray-300">
                      <div>
                      <h3 className='text-m mt-1 mx-1 text-yellow-200'>{noteFlexPages.length} Page Found!</h3>
                      </div>
                      <div className='mr-4'>
                      {/* <Link to='/noteflex/add' className='block w-full h-full px-1 py-2 ml-4 bg-blue-500'>
                        <FontAwesomeIcon className="bg-blue-500 mr-4" icon={faPlus} />  Setup A Page
                      </Link> */}
                      <Link
                          to={`/noteflex/add`}
                          state={{ pageNumberList: pageNumberList }}
                          className='block w-full h-full px-1 py-2 ml-4 bg-blue-500'
                        >
                          <FontAwesomeIcon className="bg-blue-500 mr-4" icon={faPlus} />  Setup A Page
                      </Link>
                    </div>
                  </div>
                  )}
              </div>
              {loading ? (
                <Loader />
              ) : (
                <div>
                  {noteFlexPages && noteFlexPages.length === 0 ? (
                    <div className='min-h-[300px] flex items-center justify-center gap-4 text-yellow-300'>
                      <div className="flex justify-between items-center">
                        <h3 className='text-lg mt-1 mx-2 text-orange-400'>Your Own Page Not Found!</h3>
                        <div>
                          {/* <Link to='/noteflex/add' className='block w-full h-full px-1 py-2 ml-4 bg-blue-500'>
                            <FontAwesomeIcon className="bg-blue-500 mr-4" icon={faPlus} />  Setup A Page
                          </Link> */}
                          <Link
                              to={`/noteflex/add`}
                              state={{ pageNumberList: pageNumberList }}
                              className='block w-full h-full px-1 py-2 ml-4 bg-blue-500'
                            >
                              <FontAwesomeIcon className="bg-blue-500 mr-4" icon={faPlus} />  Setup A Page
                          </Link>
                        </div>
                    </div>
                  </div>
                  ) : (
                    sortedNoteFlexPages.map((noteFlexPage, index) => (
                      <div key={noteFlexPage._id} className='bg-gray-600 my-1 p-1 text-white rounded-md shadow-md text-sm'>
                        <div className='flex'>
                          <span className='font-medium'>{noteFlexPage.pageNumber}{'. '}{noteFlexPage.pageTitle}</span>
                          <Tooltip text={"View details"} position={"top"}>
                            <span className='ml-auto mr-4 text-blue-500 cursor-pointer' onClick={() => handleView(noteFlexPage._id)}>
                              <i className="fa-solid fa-eye"></i>
                            </span>
                          </Tooltip>
                          <Tooltip text={"Edit this record"} position={"top"}>
                            <Link
                              to={`/noteflex/${noteFlexPage._id}`}
                              state={{ pageNumberList: pageNumberList }}
                              className='mr-4 text-green-600 cursor-pointer'
                            >
                              <i className="fa-solid fa-pen"></i>
                            </Link>
                          </Tooltip>
                          <Tooltip text={"Delete this record"} position={"top"}>
                            <span className='text-red-500 cursor-pointer mr-2' onClick={() => deleteClicked(noteFlexPage._id)}>
                              <i className="fa-solid fa-trash"></i>
                            </span>
                          </Tooltip>
                          { isDeleteClicked && (
                            <div
                              className="fixed inset-0 bg-black bg-opacity-80 flex items-center justify-center"
                              style={{ zIndex: 1000 }}
                            >
                              <div className="w-6/12 flex flex-row justify-center bg-blue-200 text-black border-b border-b-gray-300 mr-4 ml-4 p-4">
                                  <button
                                    className="bg-red-700 w-40"
                                    onClick={() =>  handleDelete(deletePageId) }
                                    style={{ maxWidth: "150px" }}
                                  >
                                    Confirm To Delete
                                  </button>
                                  <button
                                    className="bg-yellow-300 ml-4 text-black w-40"
                                    onClick={() =>  noDeleteClicked() }
                                    style={{ maxWidth: "150px" }}
                                  >
                                    No I Do Not Want To Delete
                                  </button>
                              </div>
                            </div>
                          )}
                        </div>
                        {selectedNoteFlexPageId === noteFlexPage._id && (
                          <div className='bg-gray-600 text-white'>
                            <p className='bg-blue-700 text-white justify-center text-m mt-2 mb-2'>
                              <h2 className='text-white'><strong>Page Details</strong></h2>
                            </p>
                            <p><strong>Page#:</strong> {noteFlexPage.pageNumber}</p>
                            <p><strong>Page Title:</strong> {noteFlexPage.pageTitle}</p>
                            <p className='border-2 border-lime-600 px-4 py-4'><strong className='text-yellow-200'>Page Content:</strong>  <br/>
                              <div
                                className="ml-2 mr-2 flex items-start"
                                style={{ minHeight: "100%", position: 'relative', top: 0, left: 0, right: 0 }}
                                dangerouslySetInnerHTML={{ __html: noteFlexPage.pageContent }}
                              />
                            </p>
                            <p><strong>Is Hidden Text:</strong> {noteFlexPage.isSplText === 1 ? "Yes":"No"}</p>
                            <p className='border-2 border-lime-600 px-4 py-4'><strong className='text-yellow-200'>Hidden Text:</strong><br/>
                              {noteFlexPage.splTextContent}
                            </p>
                            <p><strong>Speak Hidden Text:</strong> {noteFlexPage.readFromSplText ? "Yes":"No"}</p>
                            <p><strong>Show Page Video:</strong> {noteFlexPage.hasVideo ? "Yes":"No"}</p>
                            <p><strong>Video URL:</strong> {noteFlexPage.videoURL}</p>
                            <p><strong>Page Keywords:</strong> {noteFlexPage.searchTags}</p>
                            <p><strong>Date Created:</strong> {formatDateTime(noteFlexPage.createdDate)}</p>
                            <p><strong>Creator Name:</strong> {noteFlexPage.createdByName}</p>

                            <Tooltip text={"Share"} position={"top"}>
                              <span className='text-green-500 cursor-pointer mr-4' disabled={true} onClick={() => handleNoteFlexPageShare(noteFlexPage._id)}>
                                <i className="fa-solid fa-share"></i>
                              </span>
                            </Tooltip>
                            <Tooltip text={"Save"} position={"top"}>
                              <span className='text-blue-500 cursor-pointer mr-4' disabled={true} onClick={() => handleNoteFlexPageSave(noteFlexPage._id)}>
                                <i className="fa-solid fa-save"></i>
                              </span>
                            </Tooltip>
                            <Tooltip text={"Print"} position={"top"}>
                              <span className='text-orange-500 cursor-pointer mr-4' disabled={true} onClick={() => handleNoteFlexPagePrint(noteFlexPage._id)}>
                                <i className="fa-solid fa-print"></i>
                              </span>
                            </Tooltip>
                          </div>
                        )}
                      </div>
                    ))
                  )}
                </div>
              )}
            </div>
          </div>
      </MainLayout>
    </>
  )
}

export default NoteFlexPagesList